import { Component, Input } from '@angular/core';
import { AltinnApplication } from '../../../models/altinn-application/altinn-application';

@Component({
  selector: 'landing-page-sent',
  templateUrl: './landing-page-sent.component.html',
  styleUrls: ['./landing-page-sent.component.scss']
})
export class LandingPageSentComponent {
  @Input({ required: true }) application!: AltinnApplication;

}
